export default __webpack_public_path__ + "static/media/1136.c6480c03.png";